import React from 'react';
import { Icon } from '@chakra-ui/react';

const GeneralRiskObjectsHome: React.FC<React.PropsWithChildren<unknown>> = (
  props,
) => (
  <Icon viewBox="0 0 50 50" {...props}>
    <path
      fill="currentColor"
      d="M39.56 18.56L36 16.17v-5.36a1 1 0 00-1-1h-4a1 1 0 00-1 1v1.34l-4.45-3a1 1 0 00-1.1 0l-14 9.39a1 1 0 00-.45.84V40a1 1 0 001 1h6V31a1 1 0 011-1h5a1 1 0 011 1v10h15a1 1 0 001-1V19.4a1 1 0 00-.44-.84z"
    ></path>
  </Icon>
);

export default GeneralRiskObjectsHome;
